import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../../services/api';

const Pages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    try {
      const response = await apiService.getPages();
      if (response.success) {
        setPages(response.data.pages);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch pages');
    } finally {
      setLoading(false);
    }
  };

  const togglePublish = async (pageId) => {
    try {
      await apiService.togglePagePublish(pageId);
      fetchPages(); // Refresh the list
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to toggle page status');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg">
          <i className="fas fa-spinner fa-spin mr-2"></i>
          Loading pages...
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Website Pages</h1>
      </div>

      {error && (
        <div className="alert alert-error mb-4">
          {error}
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <div className="overflow-x-auto">
            <table className="table">
              <thead>
                <tr>
                  <th>Page</th>
                  <th>Title</th>
                  <th>Status</th>
                  <th>Last Modified</th>
                  <th>Modified By</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {pages.map((page) => (
                  <tr key={page._id}>
                    <td>
                      <span className="font-mono text-sm bg-gray-100 px-2 py-1 rounded">
                        /{page.pageId}
                      </span>
                    </td>
                    <td>
                      <div className="font-medium">{page.title}</div>
                    </td>
                    <td>
                      <span className={`px-2 py-1 text-xs rounded-full ${
                        page.isPublished 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {page.isPublished ? 'Published' : 'Draft'}
                      </span>
                    </td>
                    <td>
                      <div className="text-sm">
                        {new Date(page.lastModified).toLocaleDateString()}
                      </div>
                    </td>
                    <td>
                      <div className="text-sm">
                        {page.modifiedBy?.username || 'Unknown'}
                      </div>
                    </td>
                    <td>
                      <div className="flex gap-2">
                        <Link
                          to={`/admin/pages/edit/${page.pageId}`}
                          className="btn btn-primary btn-sm"
                          title="Edit Page"
                        >
                          <i className="fas fa-edit"></i>
                        </Link>
                        <button
                          onClick={() => togglePublish(page.pageId)}
                          className={`btn btn-sm ${
                            page.isPublished ? 'btn-secondary' : 'btn-success'
                          }`}
                          title={page.isPublished ? 'Unpublish' : 'Publish'}
                        >
                          <i className={`fas fa-${page.isPublished ? 'eye-slash' : 'eye'}`}></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {pages.length === 0 && (
            <div className="text-center py-8">
              <i className="fas fa-file-alt text-4xl text-gray-300 mb-4"></i>
              <p className="text-gray-600">No pages found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Pages;